import { Building, FloorData, VisitTypeData } from './types';
import { building, buildingState } from 'store/building/selectors';
import { useDispatch, useSelector } from 'react-redux';

import { OwnerIdParam } from 'shared/types';
import { fetchBuilding } from 'store/building/actions';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const useFetchBuilding = (): boolean => {
  const { ownerId } = useParams<OwnerIdParam>();
  const dispatch = useDispatch();
  const { loading } = useSelector(buildingState);

  useEffect(() => {
    dispatch(fetchBuilding.request({ ownerId }));
  }, [dispatch, ownerId]);

  return loading;
};

export const useBuildingState = (): Building | null => useSelector(building);

export const useBuildingData = (): {
  floors: FloorData[] | null;
  visitTypes: VisitTypeData[] | null;
  passEntryOptions: string[] | null;
  defaultPassEntryOption: string | null;
  supportedStatuses: string[] | null;
} => {
  const data = useBuildingState();

  return {
    floors: data?.floors ?? null,
    visitTypes: data?.visit_types ?? null,
    passEntryOptions: data?.pass_entry_options ?? null,
    defaultPassEntryOption: data?.default_pass_entry_option ?? null,
    supportedStatuses: data?.supported_statuses ?? null,
  };
};
